module.exports = __webpack_public_path__ + "static/media/logo.f96986fc.svg";